import { useMultiTierCheckout } from '../../../context';
import QuantityButtons from '../../QuantityButtons';
import { QuantityChangeEvents } from '../../../types';
import { EventTierForPublic } from '../../../../../../types';
import { currencyFormat } from 'legacy/common/utils/currency';
import { MdConfirmationNumber } from 'react-icons/md';
import { MemberOnlyTierLabel } from '../../MemberOnlyTierLabel';

type Props = {
  tier: EventTierForPublic;
};

const SummaryItem = ({ tier }: Props) => {
  const {
    data: { tickets },
    updateTicketTierQuantityAndSave
  } = useMultiTierCheckout();

  const isMemberOnlyAccess =
    tier?.requiredAssociationIds?.length > 0 ||
    tier?.requiredOrganizationIds?.length > 0;

  const onTicketQuantityChange = (event: QuantityChangeEvents) => {
    updateTicketTierQuantityAndSave(tier._id, event);
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-1 align-center">
        <div className="font-bold text-sm py-3 flex-1 pr-2">{tier.name}</div>
        <div className="w-[40px] h-[40px] bg-neutral-200 flex align-center justify-center rounded-lg overflow-hidden">
          {tier.imageUrl ? (
            <img
              src={tier.imageUrl}
              className="w-full h-full object-cover object-center"
            />
          ) : (
            <MdConfirmationNumber size={20} className="text-neutral-500" />
          )}
        </div>
      </div>
      <div className="flex justify-center align-center pt-2">
        <div className="flex flex-1">
          <QuantityButtons
            tierId={tier._id}
            remainingTicketsForTier={tier.remaining}
            selectedTicketTierQuantity={
              tickets.selectedTicketTiers[tier._id].quantity
            }
            maxTicketsPerTransaction={tickets.maxTicketsPerTransaction}
            onQuantityChange={onTicketQuantityChange}
            totalAmountOfTicketsSelected={tickets.totalAmountOfTicketsSelected}
          />
        </div>
        <div className="font-normal text-sm">{currencyFormat(tier.price)}</div>
      </div>
      {isMemberOnlyAccess && (
        <div className="mt-3 -mb-1">
          <MemberOnlyTierLabel />
        </div>
      )}
    </div>
  );
};

export default SummaryItem;
